/**
 * @flow
 * @relayHash 41c96af059bbeeb599fb007639ffc3a2
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GLAccountType = "ASSET" | "COGS" | "EQUITY" | "EXPENSE" | "LIABILITY" | "REVENUE";
export type GLNormalBalance = "CREDIT" | "DEBIT";
export type FinanceDashboardQueryVariables = {||};
export type FinanceDashboardQueryResponse = {|
  +glAccounts: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +accountNumber: string,
        +name: string,
        +accountType: GLAccountType,
        +normalBalance: GLNormalBalance,
        +balance: number,
      |}
    |}>
  |}
|};
export type FinanceDashboardQuery = {|
  variables: FinanceDashboardQueryVariables,
  response: FinanceDashboardQueryResponse,
|};
*/


/*
query FinanceDashboardQuery {
  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {
    edges {
      node {
        id
        accountNumber
        name
        accountType
        normalBalance
        balance
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "glAccounts",
    "storageKey": "glAccounts(first:200,isActive:true,sortBy:{\"direction\":\"ASC\",\"field\":\"ACCOUNT_NUMBER\"})",
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Literal",
        "name": "isActive",
        "value": true
      },
      {
        "kind": "Literal",
        "name": "sortBy",
        "value": {
          "direction": "ASC",
          "field": "ACCOUNT_NUMBER"
        }
      }
    ],
    "concreteType": "GLAccountConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "GLAccountEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "GLAccount",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "normalBalance",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "balance",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "FinanceDashboardQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "FinanceDashboardQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "FinanceDashboardQuery",
    "id": null,
    "text": "query FinanceDashboardQuery {\n  glAccounts(first: 200, isActive: true, sortBy: {field: ACCOUNT_NUMBER, direction: ASC}) {\n    edges {\n      node {\n        id\n        accountNumber\n        name\n        accountType\n        normalBalance\n        balance\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b11ece964efe7fdfb5f04eb0e5b11b8c';
module.exports = node;
